<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>营销</el-breadcrumb-item>
            <el-breadcrumb-item>分销</el-breadcrumb-item>
            <el-breadcrumb-item>分销商品</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="dis-flex">
            <div class="second-swaper">
                <second></second>
            </div>
            <div class="flex-box" style="overflow-x: hidden">
                <div class="product_tabs"
                        hidden-breadcrumb>
                    <div slot="content">
                        <Tabs @on-click="onClickTab">
                            <TabPane
                                    :label="item.name"
                                    :name="item.type"
                                    v-for="(item, index) in headeNum"
                                    :key="index"/>
                        </Tabs>
                    </div>
                </div>
                <Card :bordered="false" dis-hover class="ivu-mt">
                    <Form
                            ref="tableFrom"
                            :model="tableFrom"
                            :label-width="labelWidth"
                            :label-position="labelPosition"
                            @submit.native.prevent>
                        <Row type="flex" :gutter="24">
                            <Col v-bind="grid">
                                <FormItem label="商品搜索：" label-for="store_name">
                                    <Input
                                            search
                                            enter-button
                                            placeholder="请输入商品名称，ID"
                                            v-model="tableFrom.goods_name"
                                            @on-search="userSearchs"/>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row type="flex" class="mb20">
                            <Col v-bind="grid">
                                <Button v-auth="['market/dealer/add']" type="primary" class="bnt" icon="md-add" @click="batcnAdd" v-if="tableFrom.type == 'wait'">批量参与</Button>

                            </Col>
                        </Row>
                    </Form>
                    <Table
                            class="mt25"
                            :columns="columns1"
                            :data="tableList"
                            :loading="loading"
                            ref="selection"
                            highlight-row
                            no-userFrom-text="暂无数据"
                            no-filtered-userFrom-text="暂无筛选结果"
                            @on-selection-change="onSelectTab">

                        <template slot-scope="{ row, index }" slot="is_fail">
                            <Icon
                                    type="md-checkmark"
                                    v-if="row.is_fail === 1"
                                    color="#0092DC"
                                    size="14"/>
                            <Icon type="md-close" v-else color="#ed5565" size="14" />
                        </template>
                        <template slot-scope="{ row, index }" slot="image">
                            <div class="acea-row">
                                <viewer>
                                    <div class="tabBox_img">
                                        <img v-lazy="row.product_pic_main" />
                                    </div>
                                </viewer>
                            </div>
                        </template>
                        <template slot-scope="{ row, index }" slot="in_dealer">
                            <div class="acea-row">
                                <Tag color="blue" v-if="row.dealer_goods_id">已参与</Tag>
                                <Tag v-else>未参与</Tag>
                            </div>
                        </template>
                        <template slot-scope="{ row, index }" slot="is_ind_dealer">
                            <div class="acea-row">
                                {{row.is_ind_dealer == 1 ? '单独设置' : '默认规则'}}
                            </div>
                        </template>
                        <template slot-scope="{ row, index }" slot="action">
                            <a v-if="row.dealer_goods_id"  @click="edit(row)">佣金设置</a>
                            <Divider type="vertical" />
                            <a v-if="row.dealer_goods_id" @click="cancel(row, '删除分销商品', index)">取消分销</a>
                            <a @click="add(row)" v-else>参与分销</a>
                        </template>
                    </Table>
                    <div class="acea-row row-right page">
                        <Page
                                :total="total"
                                :current="tableFrom.page"
                                show-elevator
                                show-total
                                @on-change="pageChange"
                                :page-size="tableFrom.limit"/>
                    </div>
                </Card>
            </div>
        </div>
    </div>
</template>

<script>
    import second from "../second";

    export default {
        name: "index",
        components: { second },
        data() {
            return {
                isLoad: false,
                headeNum: [
                    { type: "", name: "全部" },
                    { type: "has", name: "已参与" },
                    { type: "wait", name: "待参与" },
                ],
                loading: false,
                columns1: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: "商品图",
                        slot: "image",
                        width: 60,
                    },
                    {
                        title: "商品名称",
                        key: "name",
                        minWidth: 250,
                    },
                    {
                        title: "是否参与",
                        slot: "in_dealer",
                        minWidth: 100,
                    },
                    {
                        title: "规则",
                        slot: "is_ind_dealer",
                        minWidth: 100,
                    },
                    {
                        title: "操作",
                        slot: "action",
                        fixed: "right",
                        minWidth: 130,
                    },
                ],
                tableList: [],
                grid: {
                    xl: 7,
                    lg: 10,
                    md: 12,
                    sm: 24,
                    xs: 24,
                },
                tableFrom: {
                    start_status: "",
                    status: "",
                    goods_name: "",
                    export: 0,
                    page: 1,
                    limit: 15,
                },
                tableFrom2: {
                    status: "",
                    store_name: "",
                    export: 1,
                },
                total: 0,
                formSelection: [],
            };
        },
        computed: {
            labelWidth() {
                return 80;
            },
            labelPosition() {
                return "left";
            },
        },
        created() {
            this.getList();
        },
        methods: {
            // 数据导出；
            async exports() {
                let [th, filekey, data, fileName] = [[], [], [], ""];
                //   let fileName = "";
                let excelData = JSON.parse(JSON.stringify(this.tableFrom));
                excelData.page = 1;
                for (let i = 0; i < excelData.page + 1; i++) {
                    let lebData = await this.getExcelData(excelData);
                    if (!fileName) fileName = lebData.filename;
                    if (!filekey.length) {
                        filekey = lebData.filekey;
                    }
                    if (!th.length) th = lebData.header;
                    if (lebData.export.length) {
                        data = data.concat(lebData.export);
                        excelData.page++;
                    } else {
                        exportExcel(th, filekey, fileName, data);
                        return;
                    }
                }
            },
            selectAll(row) {
                this.checkBox  = !this.checkBox
                if (row.length) {
                    this.selectionList = row;
                }
                this.$forceUpdate()
            },
            // 全选
            onSelectTab(selection) {
                this.selectionList = selection;
                let data = [];
                this.selectionList.map((item) => {
                    data.push(item.goods_id);
                });
                this.formSelection = data
            },
            getExcelData(excelData) {
                return new Promise((resolve, reject) => {
                    stroeBargainApi(excelData).then((res) => {
                        return resolve(res.data);
                    });
                });
            },
            onClickTab(type) {
                this.tableFrom.page = 1;
                this.tableFrom.type = type;
                this.getList();
            },
            add(row) {
                this.axios.post('/store/app.dealer.goods/add',{
                    goods_id: row.goods_id
                })
                .then(async (res) => {
                    if (res.code == 1) {
                        this.$Message.success(res.msg);
                        this.getList();
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
                .catch((res) => {
                });
            },
            batcnAdd: function () {
                this.ids = this.formSelection
                this.axios.post('/store/app.dealer.goods/add',{
                    goods_id: this.ids
                })
                .then(async (res) => {
                    if (res.code == 1) {
                        this.$Message.success(res.msg);
                        this.getList();
                    } else {
                        this.$Message.error(res.msg);
                    }
                })
                .catch((res) => {
                });

            },
            // 编辑
            edit(row) {
                this.$router.push({
                    path: "/app/dealer/goods/create.html?id=" + row.goods_id,
                });
            },
            // 删除
            cancel(row, tit, num) {
                var _this = this
                this.$Modal.confirm({
                    title: '取消分销',
                    content: '<p>确定要取消分销吗？</p>',
                    loading: true,
                    onOk: () => {
                        this.axios.post('/store/app.dealer.goods/delete', {
                            goods_id: row.goods_id
                        })
                        .then((res) => {
                            this.$Modal.remove();
                            if (res.code == 1) {
                                this.$Message.success(res.msg);
                                this.getList()
                            } else {
                                this.$Message.error(res.msg);
                            }

                        })
                        .catch((res) => {

                        });
                    }
                })
            },
            // 列表
            getList() {
                this.loading = true;
                this.tableFrom.start_status = this.tableFrom.start_status || "";
                this.tableFrom.status = this.tableFrom.status || "";
                this.axios.post('/store/app.dealer.goods/list',this.tableFrom)
                    .then(async (res) => {
                        let data = res.data;
                        this.tableList = data.list.data;
                        this.total = data.list.total;
                        this.loading = false;
                    })
                    .catch((res) => {
                        this.loading = false;
                        this.$Message.error(res.msg);
                    });
            },
            pageChange(index) {
                this.tableFrom.page = index;
                this.getList();
            },
            // 表格搜索
            userSearchs() {
                this.tableFrom.page = 1;
                this.getList();
            },
        },
    }
</script>

<style scoped>

</style>
